var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{attrs:{"id":"components-layout-demo-custom-trigger"}},[_c('sidebar'),_c('a-layout',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }